// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"QW-z","sponsoredTooltipWrapper":"RW-z","sponsoredTooltip":"SW-z","newCard":"TW-z"};